import { reviews, siteInfo } from "@/mocks/siteData";
import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/base/Reveal";

export default function ReviewsSection() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <SectionHeading
        eyebrow="Readers"
        title="读者怎么说"
        desc={`${siteInfo.name}从 ${siteInfo.since}开始记录翻车事件，读者里有内容从业者，也有每天通勤刷热点的普通网友。`}
      />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {reviews.map((item, index) => (
          <Reveal key={item.name} delay={index * 70} className="h-full">
            <figure className="flex flex-col h-full p-5 md:p-6 rounded-lg bg-background-100 border border-background-200">
              <i className="ri-double-quotes-l text-3xl text-primary-300"></i>
              <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700 flex-1">
                {item.text}
              </blockquote>
              <figcaption className="mt-5 pt-4 border-t border-background-300 flex items-center gap-3">
                <span className="w-9 h-9 rounded-full bg-secondary-200 text-secondary-900 flex items-center justify-center text-sm font-semibold">
                  {item.name.slice(0, 1)}
                </span>
                <span className="flex flex-col">
                  <span className="text-sm font-medium text-foreground-950">{item.name}</span>
                  <span className="text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}